const QuoteCard = ({ name, title, quote, avatar }) => {
    return (
        <figure className="card flex h-full flex-col gap-5 p-6 sm:gap-6 sm:p-8">
            <span aria-hidden className="font-serif text-6xl leading-none text-sky-500 h-8">&ldquo;</span>
            <blockquote className="flex-1 leading-relaxed text-slate-700 dark:text-slate-300">
                {quote}
            </blockquote>
            <figcaption className="flex items-center gap-4 border-t border-slate-200 pt-5 sm:pt-6 dark:border-white/10">
                <img className="h-12 w-12 rounded-full object-cover" src={avatar} alt={name} />
                <div className="flex flex-col">
                    <span className="font-medium text-slate-900 dark:text-white">{name}</span>
                    <span className="text-sm text-slate-500 dark:text-slate-400">{title}</span>
                </div>
            </figcaption>
        </figure>
    );
};

export default QuoteCard;
